import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryFirstImageUrl,
    getItemSummaryLotNumber,
    getItemSummaryTitle,
    getItemSummaryUrl,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { addImageParams } from '@/utils/urls';

type Props = {
    itemId: number;
    lastItem?: boolean;
    onClick?: () => void;
};

const UpcomingItemLinkComponent = ({ itemId, lastItem = false, onClick }: Props) => {
    const itemUrl = useAppSelector((state) => getItemSummaryUrl(state, itemId));
    const title = useAppSelector((state) => getItemSummaryTitle(state, itemId));
    const firstPhoto = useAppSelector((state) => getItemSummaryFirstImageUrl(state, itemId));
    const nextImageUrl = addImageParams({ url: firstPhoto, width: 375 });
    const lotNumber = useAppSelector((state) => getItemSummaryLotNumber(state, itemId));

    return (
        <div
            className={cn(
                'relative flex w-[calc(100%/3)] cursor-pointer justify-center overflow-hidden',
                'xsMax:absolute xsMax:top-0 xsMax:right-0 xsMax:z-[4] xsMax:h-[125px] xsMax:w-[125px] xsMax:bg-surface-200',
                lastItem ? 'p-md xsMax:hidden' : 'py-md xsMax:p-0'
            )}
        >
            <RouteLink
                className="flex h-full w-full items-center justify-center"
                onClick={onClick}
                to={itemUrl}
            >
                <div
                    className={cn(
                        'absolute bottom-[15px] left-[15px] z-[3] h-[26px] rounded-[13px] bg-[rgba(0,0,0,0.5)] px-sm text-center font-primary leading-[26px] text-text-inverse',
                        'xsMax:bottom-0 xsMax:left-auto xsMax:h-auto xsMax:p-2xs xsMax:text-sm xsMax:leading-normal',
                        { hidden: lastItem }
                    )}
                >
                    <FormattedMessage
                        id="next_lot_number"
                        values={{ lotNumber }}
                    />
                </div>
                <div className="relative z-[2] flex items-center justify-center">
                    <img
                        alt={title}
                        className="max-h-full max-w-full object-contain xsMax:h-auto xsMax:w-[120px] xsMax:border-none"
                        src={nextImageUrl}
                    />
                </div>
            </RouteLink>
        </div>
    );
};

export const UpcomingItemLink = UpcomingItemLinkComponent;
